<template>
  <div class="privacy">
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="個人情報保護方針" />
    <div class="body">
      <div class="privacy-content">
        株式会社ビーアッサ（以下､｢当社｣といいます）は、お客さまに個人情報のご提供をお願いする際、予めその利用目的を明示致します。<br />
        お客さまにご提供いただいた個人情報は、利用目的の範囲内で利用し、お客さまの同意なく利用目的以外に利用いたしません。<br />
        お客さまが個人情報の提供をご希望されない場合、お客さまご自身のご判断により、個人情報の提供を拒否することが可能です。<br />
        この場合、当ウェブサイトにおけるサービスをご利用いただけないことがございますので、予めご了承ください。
      </div>
      <div class="privacy-content">
        <div class="privacy-header">
          １．個人情報の取得、利用及び提供について
        </div>
        <div class="privacy-body">
          当社は個人情報を直接取得する場合は、利用目的を明示し、本人の同意の上、適正な取得、利用及び提供を行います。<br />
          また、利用目的以外に利用することはありません。<br />
          個人情報の利用目的の範囲内において、個人情報を含む業務を外部委託する場合は、契約書等により個人情報の適正な管理を求め、監督を行います。<br />
          個人情報を第三者に提供する場合は、事前に本人から同意を得ることとします。<br />
          なお、法令による場合はこの限りではありません。
        </div>
      </div>
      <div class="privacy-content">
        <div class="privacy-header">
          ２．個人情報の第三者提供
        </div>
        <div class="privacy-body">
          当社は、お客さまにご提供いただいた個人情報を、次の場合を除き第三者に開示いたしません。<br />
          <br />
          ・お客さまの同意がある場合<br />
          ・個人情報に関する機密保持契約を締結している協力企業、提携会社および業務委託会社に対して、<br />
          &emsp;お客さまに明示した利用目的の達成に必要な範囲で個人情報の取扱いを委託する場合。<br />
          ・法令などに基づき、提供に応じなければならない場合。
        </div>
      </div>
      <div class="privacy-content">
        <div class="privacy-header">
          3．個人情報の安全管理
        </div>
        <div class="privacy-body">
          当社は、ご提供いただいた個人情報を厳重に保管・管理し、第三者の不正なアクセスによる個人情報の漏洩・流用・改ざんなどを防止するため、ファイアウォール設置（下記参照）・コンピューターウイルス対策、その他合理的なセキュリティー対策を講じます。
        </div>
      </div>
      <div class="privacy-content">
        <div class="privacy-header">
          ４．照会・訂正・削除など
        </div>
        <div class="privacy-body">
          当社が保有するお客様情報に関して、お客様がご希望される場合には、お申し出いただいた方がご本人であることまたは正当な代理人であることを確認した上で、お客様の個人情報を開示し、ご指示により合理的な範囲内で内容の訂正・削除もします。
        </div>
      </div>
      <div class="privacy-content">
        <div class="privacy-header">
          個人情報に関するお問合せ窓口
        </div>
        <div class="privacy-body">
          <p style="font-size: 18px; font-weight: bold; margin: 3px 0;">
            株式会社ビーアッサ
          </p>
          本&emsp;社：〒922-0101 石川県加賀市山中温泉中田町ハ-101<br />
          営業所：〒921-8811 石川県野々市市高橋町10-18<br />
          TEL : 076-294-4440 &emsp;FAX : 076-294-4432 &emsp;E-MAIL :
          info@b-call.jp
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  components: {
    HeaderBanner,
    Breadcrumb,
  },
  title: '個人情報保護方針｜B-Call（ビーコール）',
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '個人情報保護方針',
            path: 'https://b-call.jp/privacy',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.privacy .body {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.privacy .body .privacy-content {
  margin-bottom: 40px;
}

.privacy-content .privacy-header {
  font-size: 18px;
  font-weight: bold;

  padding-bottom: 8px;

  color: rgb(9, 81, 141);
  border-bottom: 1px solid rgb(199, 199, 199);
}

.privacy-content .privacy-body {
  font-size: 15px;

  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Privacy.vue